import {
  ERROR_MANAGEMENT_ASSIGN_REQUEST,
  ERROR_MANAGEMENT_ASSIGN_SUCCESS,
  ERROR_MANAGEMENT_ASSIGN_FAILURE,
  ERROR_MANAGEMENT_FETCH_REQUEST,
  ERROR_MANAGEMENT_FETCH_SUCCESS,
  ERROR_MANAGEMENT_FETCH_FAILURE,
} from '../actions/error_management'

export function errorManagement(
  state = {
    isFetching: false,
    errors: null,
    errorMessage: null,
  },
  action
) {
  switch (action.type) {
    case ERROR_MANAGEMENT_ASSIGN_REQUEST:
      return {
        ...state,
        isFetching: true,
        errorMessage: null,
      }
    case ERROR_MANAGEMENT_ASSIGN_SUCCESS:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
      }
    case ERROR_MANAGEMENT_ASSIGN_FAILURE:
      return {
        ...state,
        isFetching: false,
        errorMessage: action.error,
      }
    case ERROR_MANAGEMENT_FETCH_REQUEST:
      return {
        ...state,
        errors: null,
        isFetching: true,
        errorMessage: null,
      }
    case ERROR_MANAGEMENT_FETCH_SUCCESS:
      return {
        ...state,
        errorMessage: null,
        isFetching: false,
        errors: action.response.results,
      }
    case ERROR_MANAGEMENT_FETCH_FAILURE:
      return {
        ...state,
        errors: null,
        isFetching: false,
        errorMessage: action.error,
      }
    default:
      return state
  }
}
